<template>
  <div class="uk-container uk-margin-large-bottom">
    <p>
      <router-link :to="{name: 'Trial'}" v-show="step === 1">{{i18n["buy-subline"]}}</router-link>
    </p>
    <div uk-grid class="uk-grid-collapse uk-grid-divider uk-child-width-expand@s">
      <div class="uk-width-2-3@m">
        <div class="form-wrapper">
          <transition name="fade">
            <div v-if="status !== 'done'">
              <progress v-show="step < 6" class="uk-progress" :value="16.66 * step" max="100"></progress>
              <ul class="uk-list">
                <li v-if="step === 1">
                  <div v-if="customer.plan.variant !== 'educational'">
                    <h2>1. {{i18n["step1-headline"]}}</h2>
                    <ValidationObserver ref="step1" v-slot="{ invalid }">
                      <form class="uk-form-stacked" novalidate @submit.stop.prevent="toStep(2)">
                        <div uk-grid>
                          <div class="uk-width-1-4@m">
                            <label class="uk-form-label" for="form-stacked-text">{{i18n["step1-numberofusers"]}}</label>
                            <div class="uk-form-controls">
                              <input min="1" class="uk-input uk-form-width-small" id="planUsers" name="planUsers" type="number" v-model="customer.plan.users">
                            </div>
                            <div v-show="customer.plan.users > 250" class="uk-margin" v-html="i18n['step1-numberofuserserrormax']"></div>
                          </div>
                          <div class="uk-width-2-3@s">
                            <div class="uk-flex">
                              <div class="planchooser uk-text-center yearly uk-width-1-2" :class="{inactive: customer.plan.interval === 'monthly'}" v-on:click="customer.plan.interval = 'yearly'">
                                <div class="header">
                                  {{i18n["planchooser-mostpopular"]}}
                                </div>
                                <div class="content">
                                  <h4>{{i18n["planchooser-billedyearly"]}}<span class="uk-text-primary">{{i18n["planchooser-savings"]}} {{yearlySavingsProcComp}}%</span></h4>
                                  <h5>{{totalStorageComp}}</h5>
                                  <p>
                                    {{billwerk.plans[customer.plan.variant].yearly.price / 12 | currency(currencies[activeCurrency])}} {{i18n["planchooser-peruserpermonth"]}}
                                  </p>
                                  <p>
                                    {{yearlyTotalComp | currency(currencies[activeCurrency])}} {{i18n["planchooser-chargeyearly"]}}
                                  </p>
                                </div>
                              </div>
                              <div class="planchooser uk-text-center uk-width-1-2" :class="{inactive: customer.plan.interval === 'yearly'}" v-on:click="customer.plan.interval = 'monthly'">
                                <div class="header uk-padding">&nbsp;</div>
                                <div class="content">
                                  <h4>{{i18n["planchooser-billedmonthly"]}}<span class="uk-text-primary">&nbsp;</span></h4>
                                  <h5>{{totalStorageComp}}</h5>
                                  <p>
                                    {{billwerk.plans[customer.plan.variant].monthly.price | currency(currencies[activeCurrency])}} {{i18n["planchooser-peruserpermonth"]}}
                                  </p>
                                  <p>
                                    {{monthlyTotalComp | currency(currencies[activeCurrency])}} {{i18n["planchooser-chargemonthly"]}}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div class="uk-margin uk-text-small">
                              <template v-if="customer.plan.interval === 'monthly'">
                                <p>
                                  {{i18n["planchooser-yourselectiontextmonthly"]}}
                                </p>
                              </template>

                              <template v-else-if="customer.plan.interval === 'yearly'">
                                <p>
                                  {{i18n["planchooser-yourselectiontextyearly"]}}
                                </p>
                              </template>
                            </div>

                            <div v-show="status === 'too_much_users'">
                              <div uk-alert class="uk-text-small" v-html="i18n['planchooser-basic-hint-users']">

                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="coupon-wrap uk-margin">
                          <ValidationProvider name="coupon" v-slot="{ errors, classes }">
                            <div class="uk-margin uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                              <div>
                                <label class="uk-form-label" for="coupon">{{i18n["step1-adddiscountcode"]}}</label>
                                <div class="uk-form-controls uk-position-relative">
                                  <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="customer.data.coupon !== '' && errors.length === 0"></i>
                                  <input class="uk-input" v-model="customer.data.coupon" type="text" :class="classes">
                                </div>
                              </div>

                              <div class="field-check uk-width-1-4@m">
                                <label class="uk-form-label uk-visible@m">&nbsp;</label>
                                <span class="uk-form-danger" v-if="errors.length > 0"><i class="fas fa-times"></i> {{i18n["step1-invalidcoupon"]}}</span>
                                <span class="uk-form-success uk-visible@m" v-show="coupon.status === true && customer.data.coupon != '' && errors.length === 0"><i class="fas fa-check"></i></span>
                                <span class="uk-visible@m" v-show="checkField === 'coupon'"><i class="fas fa-circle-notch fa-spin"></i></span>
                              </div>
                            </div>
                          </ValidationProvider>
                        </div>

                        <div class="uk-flex uk-flex-right uk-margin-top">
                          <button class="uk-button uk-button-primary" type="submit" :disabled="invalid || status === 'updateing_summary'">{{i18n["button-next"]}} <i class="fas fa-arrow-right"></i></button>
                        </div>
                      </form>
                    </ValidationObserver>
                  </div>

                  <div v-else>
                    <form class="uk-form-stacked" novalidate @submit.stop.prevent="toStep(2)">
                      <div class="uk-grid" uk-height-match=".list" uk-grid>
                        <div class="uk-width-1-2@s" v-for="variant in i18n.plans.educational.planVariants" :key="variant.id" >
                          <div class="uk-card uk-card-default uk-card-hover uk-card-body" :class="{'uk-card-secondary': billwerk.plans.educational.selected === variant.id }">
                            <h3 class="uk-text-center">{{variant.name}}</h3>
                            <div v-html="variant.text">
                            </div>
                            <button type="button" class="uk-button uk-display-block uk-button-primary uk-width-1-1" v-on:click="eduSelect(variant.id)">{{i18n["button-select"]}}</button>
                          </div>
                        </div>
                      </div>
                      <div class="uk-flex uk-flex-right uk-margin-top">
                        <button class="uk-button uk-button-primary" type="submit" :disabled="status === 'saving'">{{i18n["button-next"]}} <i class="fas fa-arrow-right"></i></button>
                      </div>
                    </form>
                  </div>
                </li>

                <li v-if="step === 2">
                  <h2>2. {{i18n["step2-headline"]}}</h2>
                  <ValidationObserver ref="step2" v-slot="{ invalid, errors }">
                    <form class="uk-form-stacked" novalidate @submit.stop.prevent="toStep(3)">
                      <ValidationProvider name="firstName" rules="required" v-slot="{ failed, dirty, passed, classes }" tag="div" class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                        <div>
                          <label class="uk-form-label" for="firstName">{{i18n["step2-firstname"]}}</label>
                          <div class="uk-form-controls uk-position-relative">
                            <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed"></i>
                            <input class="uk-input" v-model="customer.data.firstName" type="text" :class="classes">
                          </div>
                        </div>

                        <div class="field-check uk-width-1-4@m">
                          <label class="uk-form-label uk-visible@m">&nbsp;</label>
                          <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> {{i18n["step2-firstnameerror"]}}</span>
                          <span class="uk-form-success uk-visible@m" v-show="passed"><i class="fas fa-check"></i></span>
                        </div>
                      </ValidationProvider>

                      <ValidationProvider name="lastName" rules="required" v-slot="{ failed, dirty, passed, errors, classes }" tag="div" class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                        <div>
                          <label class="uk-form-label" for="lastName">{{i18n["step2-lastname"]}}</label>
                          <div class="uk-form-controls uk-position-relative">
                            <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed"></i>
                            <input class="uk-input" v-model="customer.data.lastName" type="text" :class="classes">
                          </div>
                        </div>

                        <div class="field-check uk-width-1-4@m">
                          <label class="uk-form-label uk-visible@m">&nbsp;</label>
                          <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> <span>{{ errors[0] }}</span> {{i18n["step2-lastnameerror"]}}</span>
                          <span class="uk-form-success uk-visible@m" v-show="passed"><i class="fas fa-check"></i></span>
                        </div>
                      </ValidationProvider>

                      <ValidationProvider name="street" rules="required" v-slot="{ failed, dirty, passed, errors, classes }" tag="div" class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                        <div>
                          <label class="uk-form-label" for="street">{{i18n["step2-street"]}}</label>
                          <div class="uk-form-controls uk-position-relative">
                            <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed"></i>
                            <input class="uk-input" v-model="customer.data.street" type="text" :class="classes">
                          </div>
                        </div>

                        <div class="field-check uk-width-1-4@m">
                          <label class="uk-form-label uk-visible@m">&nbsp;</label>
                          <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> <span>{{ errors[0] }}</span> {{i18n["step2-streeterror"]}}</span>
                          <span class="uk-form-success uk-visible@m" v-show="passed"><i class="fas fa-check"></i></span>
                        </div>
                      </ValidationProvider>

                      <div class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                        <div>
                          <div uk-grid>
                            <ValidationProvider vid="postalCode" name="postalCode" rules="required|required:@city" v-slot="{ passed, classes }" tag="div" class="uk-form-controls uk-width-1-3">
                              <label class="uk-form-label" for="postalCode">{{i18n["step2-zip"]}}</label>
                              <div class="uk-form-controls uk-position-relative">
                                <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed"></i>
                                <input class="uk-input" v-model="customer.data.postalCode" type="text" :class="classes">
                              </div>
                            </ValidationProvider>

                            <ValidationProvider vid="city" name="city" rules="required" v-slot="{ passed, classes }" tag="div" class="uk-form-controls uk-position-relative uk-width-2-3">
                              <label class="uk-form-label" for="city">{{i18n["step2-city"]}}</label>
                              <div class="uk-form-controls uk-position-relative">
                                <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed"></i>
                                <input class="uk-input" v-model="customer.data.city" type="text" :class="classes">
                              </div>
                            </ValidationProvider>
                          </div>
                        </div>

                        <div class="field-check uk-width-1-4@m">
                          <label class="uk-form-label uk-visible@m">&nbsp;</label>
                          <span class="uk-form-danger" v-if="errors.postalCode && errors.postalCode.length > 0"><i class="fas fa-times"></i> {{errors['postalCode'][0]}}</span>
                          <span class="uk-form-success uk-visible@m" v-show="errors.postalCode && errors.postalCode.length === 0 && customer.data.postalCode.length > 0 && customer.data.city.length > 0"><i class="fas fa-check"></i></span>
                        </div>
                      </div>

                      <ValidationProvider name="country" rules="required" v-slot="{ failed, dirty, passed, errors, classes }" tag="div"  class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                        <div>
                          <label class="uk-form-label" for="country">{{i18n["step2-country"]}}</label>
                          <div class="uk-form-controls uk-position-relative">
                            <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed"></i>
                            <select class="uk-select" id="country" v-model="customer.data.country" :class="classes">
                              <option v-for="(country, index) in countries.getNames(i18n.language)" :key="index" :value="index">{{country}}</option>
                            </select>
                          </div>
                        </div>

                        <div class="field-check uk-width-1-4@m">
                          <label class="uk-form-label uk-visible@m">&nbsp;</label>
                          <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> <span>{{ errors[0] }}</span> {{i18n["step2-countryerror"]}}</span>
                          <span class="uk-form-success uk-visible@m" v-show="passed"><i class="fas fa-check"></i></span>
                        </div>
                      </ValidationProvider>

                      <div class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                        <div>
                          <label><input class="uk-radio" type="radio" name="customerType" v-model="customer.type" value="B"> {{i18n['step2-b2b']}}</label>
                        </div>

                        <div>
                          <label><input class="uk-radio" type="radio" name="customerType" v-model="customer.type" value="C"> {{i18n['step2-b2c']}}</label>
                        </div>
                      </div>

                      <template v-if="customer.type === 'B'">
                        <ValidationProvider name="company" rules="" v-slot="{ failed, dirty,  errors, classes }" tag="div" class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                          <div>
                            <label class="uk-form-label" for="company">{{i18n["step2-companyname"]}} (optional)</label>
                            <div class="uk-form-controls uk-position-relative">
                              <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="customer.data.company !== ''"></i>
                              <input class="uk-input" v-model="customer.data.company" type="text" :class="classes">
                            </div>
                          </div>

                          <div class="field-check uk-width-1-4@m">
                            <label class="uk-form-label uk-visible@m">&nbsp;</label>
                            <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> <span>{{ errors[0] }}</span> {{i18n["step2-companynameerror"]}}</span>
                            <span class="uk-form-success uk-visible@m" v-show="customer.data.company !== ''"><i class="fas fa-check"></i></span>
                          </div>
                        </ValidationProvider>

                        <div v-if="vatRequired" class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                          <div>
                            <div uk-grid>
                              <ValidationProvider vid="vatprefix" name="vatprefix" rules="" tag="div" class="uk-form-controls uk-width-1-3">
                                <label class="uk-form-label" for="vat">{{i18n["step2-vat"]}}</label>
                                <div class="uk-form-controls uk-position-relative">
                                  <select class="uk-select" id="vatprefix" v-model="customer.data.vatprefix">
                                    <option v-for="(country, index) in europeanCountries" :key="index" :value="country">{{country}}</option>
                                  </select>
                                </div>
                              </ValidationProvider>

                              <ValidationProvider name="vat" rules="" tag="div"  class="uk-form-controls uk-width-2-3">
                                <div>
                                  <label class="uk-form-label" for="vat">&nbsp;</label>
                                  <div class="uk-form-controls uk-position-relative">
                                    <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="checkField !== 'vat' && customer.vatValid"></i>
                                    <i class="fas fa-circle-notch fa-spin uk-form-icon uk-form-icon-flip uk-hidden@m" v-show="checkField === 'vat'"></i>
                                    <input class="uk-input" v-model="customer.data.vat" type="text">
                                  </div>
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>

                          <div>
                            <div class="field-check uk-width-1-4@m">
                              <label class="uk-form-label uk-visible@m">&nbsp;</label>
                              <span class="uk-form-danger">
                                <template v-if="checkField !== 'vat' && ((errors.vat && errors.vat.length > 0) || (errors.vatprefix && errors.vatprefix.length > 0) || !customer.vatValid)">
                                  <i class="fas fa-times"></i> {{i18n["step2-vaterror"]}}
                                </template>
                              </span>
                              <span class="uk-form-success uk-visible@m" v-if="customer.vatValid && customer.data.vat.length > 0 && checkField !== 'vat'"><i class="fas fa-check"></i></span>
                              <span class="uk-visible@m" v-show="checkField === 'vat'"><i class="fas fa-circle-notch fa-spin"></i></span>
                            </div>
                          </div>
                        </div>
                      </template>

                      <div class="uk-flex uk-flex-between uk-margin-top">
                        <button class="uk-button uk-button-secondary" type="button" v-on:click="previousStep"><i class="fas fa-arrow-left"></i> {{["i18n"]["button-previous"]}}</button>
                        <button class="uk-button uk-button-primary" type="submit" :disabled="invalid || checkField !== '' || (vatRequired && (customer.vatValid !== true || customer.data.vat === ''))">{{i18n["button-next"]}} <i class="fas fa-arrow-right"></i></button>
                      </div>
                    </form>
                  </ValidationObserver>
                </li>

                <li v-if="step === 3">
                  <h2>3. {{i18n["step3-headline"]}}</h2>

                  <div v-html="i18n['step3-text']"></div>
                  <ValidationObserver ref="step3" v-slot="{ invalid, handleSubmit }" tag="div">
                    <form class="uk-form-stacked" novalidate @submit.prevent="handleSubmit(toStep(4))">
                      <div class="uk-child-width-expand@s" uk-grid>
                        <div>
                          <label class="uk-form-label" for="email">{{i18n["step3-email"]}}</label>
                          <div class="uk-form-controls uk-position-relative">
                            <template v-if="checkField === ''">
                              <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="emailValid"></i>
                            </template>
                            <i class="fas fa-circle-notch fa-spin uk-form-icon uk-form-icon-flip uk-hidden@m" v-show="checkField === 'email'"></i>
                            <input class="uk-input" v-model="customer.data.email" type="text" v-bind:class="{'uk-form-success': emailValid, 'uk-form-danger': emailValid == false}">
                          </div>
                        </div>

                        <div class="field-check uk-width-1-4@m">
                          <label class="uk-form-label uk-visible@m">&nbsp;</label>
                          <span class="uk-form-danger" v-if="emailValid === false"><i class="fas fa-times"></i> {{i18n["step3-emailerror"]}}</span>
                          <span class="uk-form-success uk-visible@m" v-show="emailValid && checkField !== 'email'"><i class="fas fa-check"></i></span>
                          <i class="fas fa-circle-notch fa-spin uk-visible@m" v-show="checkField === 'email'"></i>
                        </div>
                      </div>

                      <ValidationProvider name="phone" rules="" v-slot="{ dirty, passed, classes }" tag="div" class="uk-child-width-expand@s" uk-grid>
                        <div>
                          <label class="uk-form-label" for="phone">{{i18n["step3-phone"]}}</label>
                          <div class="uk-form-controls uk-position-relative">
                            <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="dirty && passed"></i>
                            <input class="uk-input" v-model="customer.data.phone" type="text" :class="classes">
                          </div>
                        </div>

                        <div class="field-check uk-width-1-4@m">
                          <label class="uk-form-label uk-visible@m ">&nbsp;</label>
                          <span class="uk-form-success uk-visible@m" v-show="dirty && passed && customer.data.phone .length > 0"><i class="fas fa-check"></i></span>
                        </div>
                      </ValidationProvider>

                      <div class="uk-flex uk-flex-between uk-margin-top">
                        <button class="uk-button uk-button-secondary" type="button" v-on:click="previousStep"><i class="fas fa-arrow-left"></i> {{["i18n"]["button-previous"]}}</button>
                        <button class="uk-button uk-button-primary" type="submit" :disabled="invalid || checkField !== '' || !emailValid">{{i18n["button-next"]}} <i class="fas fa-arrow-right"></i></button>
                      </div>
                    </form>
                  </ValidationObserver>
                </li>

                <li v-if="step === 4" class="cloudoffice">
                  <div class="uk-clearfix" v-html="i18n['step5-content']"></div>
                  <hr />
                  <form class="uk-clearfix uk-form-stacked" novalidate @submit.stop.prevent="billwerk.plans.cloudoffice.booked = true; toStep(5);">
                    <div class="uk-child-width-expand@s" uk-grid>
                      <div class="uk-flex uk-flex-column">
                        <button class="uk-button uk-button-primary" type="submit">{{i18n['step5-button-add']}} <i class="fas fa-arrow-right"></i></button>
                        <a href="#" v-on:click="billwerk.plans.cloudoffice.booked = false; toStep(5)" class="uk-text-right uk-margin-top">{{i18n['step5-button-noadd']}} <i class="fas fa-arrow-right"></i></a>
                      </div>

                      <div class="uk-flex-first@s">
                        <button class="uk-button uk-button-secondary" type="button" v-on:click="previousStep"><i class="fas fa-arrow-left"></i> {{i18n["button-previous"]}}</button>
                      </div>
                    </div>
                  </form>
                </li>

                <li v-if="step === 5" class="payment">
                  <h2>{{i18n["step4-headline"]}} <i class="fas fa-lock fa-xs"></i></h2>

                  <div class="uk-margin">
                      <div class="uk-form-controls">
                          <label class="uk-margin-right uk-margin-bottom uk-display-block uk-display-inline@s"><input class="uk-radio" v-model="customer.payment.type" value="ccard" type="radio" name="paymentType">
                            <img class="uk-margin-small-right ccardicon" :src="wpParams.template_path + '/assets/img/vue/cc-visa.png'" />
                            <img class="uk-margin-small-right ccardicon" :src="wpParams.template_path + '/assets/img/vue/cc-mastercard.png'" />
                            <img class="uk-margin-small-right ccardicon" :src="wpParams.template_path + '/assets/img/vue/cc-amex.png'" />
                            <img class="uk-margin-small-right ccardicon" :src="wpParams.template_path + '/assets/img/vue/cc-discover.png'" />
                            <img class="uk-margin-small-right ccardicon" :src="wpParams.template_path + '/assets/img/vue/cc-diners.png'" />
                            <img class="uk-margin-small-right ccardicon" :src="wpParams.template_path + '/assets/img/vue/cc-jcb.png'" />
                          </label>
                          <label class="uk-margin-right uk-display-block uk-display-inline@s"><input class="uk-radio" v-model="customer.payment.type" value="debit" type="radio" name="paymentType"> {{i18n["step4-debit_sepa"]}}</label>

                      </div>
                  </div>

                  <ValidationObserver ref="step5" v-slot="{ invalid, errors, handleSubmit }" tag="div">
                    <form class="uk-form-stacked" novalidate @submit.prevent="handleSubmit(toStep(6))">
                      <template v-if="customer.payment.type === 'ccard'">
                        <ValidationProvider name="ccholder" rules="required" v-slot="{ failed, dirty, passed, classes }" tag="div" class="uk-child-width-expand@s" uk-grid>
                          <div>
                            <label class="uk-form-label" for="email">{{i18n["step4-ccholder"]}}</label>
                            <div class="uk-form-controls uk-position-relative">
                              <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="dirty && passed"></i>
                              <input class="uk-input" v-model="customer.payment.ccard.cardHolder" type="text" :class="classes">
                            </div>
                          </div>

                          <div class="field-check uk-width-1-4@m">
                            <label class="uk-form-label uk-visible@m ">&nbsp;</label>
                            <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> {{i18n["step4-ccholdererror"]}}</span>
                            <span class="uk-form-success uk-visible@m" v-show="dirty && passed"><i class="fas fa-check"></i></span>
                          </div>
                        </ValidationProvider>

                        <ValidationProvider name="ccnumber" rules="required|credit_card" v-slot="{ failed, dirty, passed, classes }" tag="div" class="uk-child-width-expand@s" uk-grid>
                          <div>
                            <label class="uk-form-label" for="ccnumber">{{i18n["step4-ccnumber"]}}</label>
                            <div class="uk-form-controls uk-position-relative">
                              <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="dirty && passed"></i>
                              <input class="uk-input" id="ccnumber" v-model="customer.payment.ccard.cardNumber" type="text" :class="classes">
                              <div class="uk-text-small" v-if="passed">{{customer.payment.cardType}}</div>
                            </div>
                          </div>

                          <div class="field-check uk-width-1-4@m">
                            <label class="uk-form-label uk-visible@m ">&nbsp;</label>
                            <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> {{i18n["step4-ccnumbererror"]}}</span>
                            <span class="uk-form-success uk-visible@m" v-show="dirty && passed"><i class="fas fa-check"></i></span>
                          </div>
                        </ValidationProvider>

                        <ValidationProvider name="cvc" rules="max:4|min:3" v-slot="{ failed, dirty, passed, classes }" tag="div" class="uk-child-width-expand@s" uk-grid>
                          <div>
                            <label class="uk-form-label" for="cvc">{{i18n["step4-ccsecurity"]}}</label>
                            <div class="uk-form-controls uk-position-relative">
                              <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="dirty && passed"></i>
                              <input maxlength="4" class="uk-input" name="cvc" v-model="customer.payment.ccard.cvc" type="text" :class="classes">
                            </div>
                          </div>

                          <div class="field-check uk-width-1-4@m">
                            <label class="uk-form-label uk-visible@m ">&nbsp;</label>
                            <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> {{i18n["step4-ccsecurityerror"]}}</span>
                            <span class="uk-form-success uk-visible@m" v-show="dirty && passed"><i class="fas fa-check"></i></span>
                          </div>
                        </ValidationProvider>

                        <div class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                          <div>
                            <label class="uk-form-label" for="ccExpiryMonth">{{i18n["step4-ccexpires"]}}</label>
                            <div uk-grid>
                              <ValidationProvider vid="ccExpiryYear" name="ccExpiryYear" rules="required|required:@ccExpiryMonth|min_value:1" v-slot="{ dirty, passed, classes }" tag="div" class="uk-form-controls uk-position-relative uk-width-1-2">
                                <div class="uk-form-controls uk-position-relative">
                                  <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="dirty && passed"></i>
                                  <select key="expyear" class="uk-select" id="ccexpiryYear" name="ccexpiryYear" v-model="customer.payment.ccard.expiryYear" :class="classes">
                                    <option value="0" key="0" selected="selected">&nbsp;</option>
                                    <option v-for="year in ccyears" :value="year" :key="year">{{year}}</option>
                                  </select>
                                </div>
                              </ValidationProvider>

                              <ValidationProvider vid="ccExpiryMonth" name="ccExpiryMonth" rules="required|required:@ccExpiryYear|min_value:1" v-slot="{ dirty, passed, classes }" tag="div" class="uk-form-controls uk-width-1-2">
                                <div class="uk-form-controls uk-position-relative">
                                  <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="dirty && passed"></i>
                                  <select class="uk-select" name="ccexpiryMonth" v-model="customer.payment.ccard.expiryMonth" :class="classes">
                                    <option value="0" key="0" selected="selected">&nbsp;</option>
                                    <option v-for="month in ccmonths" :value="month" :key="month">{{month}}</option>
                                  </select>
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>

                          <div class="field-check uk-width-1-4@m">
                            <label class="uk-form-label uk-visible@m">&nbsp;</label>
                            <span class="uk-form-danger" v-if="(errors.ccExpiryYear && errors.ccExpiryYear.length > 0) || (errors.ccExpiryMonth && errors.ccExpiryMonth.length > 0)"><i class="fas fa-times"></i> {{i18n["step4-ccexpireserror"]}}</span>
                            <span class="uk-form-success uk-visible@m" v-show="errors.ccExpiryYear && errors.ccExpiryYear.length === 0 && customer.payment.ccard.expiryYear > 0 && errors.ccExpiryMonth && errors.ccExpiryMonth.length === 0 && customer.payment.ccard.expiryMonth > 0"><i class="fas fa-check"></i></span>
                          </div>
                        </div>

                        <ValidationProvider name="cccountry" rules="required" v-slot="{ failed, dirty, passed, errors, classes }" tag="div"  class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                          <div>
                            <label class="uk-form-label" for="cccountry">{{i18n["step4-cccountry"]}}</label>
                            <div class="uk-form-controls uk-position-relative">
                              <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed"></i>
                              <select class="uk-select" id="cccountry" v-model="customer.payment.ccard.country" :class="classes">
                                <option v-for="(country, index) in countries.getNames(i18n.language)" :key="index" :value="index">{{country}}</option>
                              </select>
                            </div>
                          </div>

                          <div class="field-check uk-width-1-4@m">
                            <label class="uk-form-label uk-visible@m">&nbsp;</label>
                            <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> <span>{{ errors[0] }}</span> {{i18n["step4-cccountryerror"]}}</span>
                            <span class="uk-form-success uk-visible@m" v-show="passed"><i class="fas fa-check"></i></span>
                          </div>
                        </ValidationProvider>
                      </template>
                      <template v-else-if="customer.payment.type === 'debit'">
                        <ValidationProvider name="debitAccountHolder" rules="required" v-slot="{ failed, dirty, passed, classes }" tag="div" class="uk-child-width-expand@s" uk-grid>
                          <div>
                            <label class="uk-form-label" for="debitAccountHolder">{{i18n["step4-debitaccountholder"]}}</label>
                            <div class="uk-form-controls uk-position-relative">
                              <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="dirty && passed"></i>
                              <input name="debitAccountHolder" class="uk-input" v-model="customer.payment.debit.accountHolder" type="text" :class="classes">
                            </div>
                          </div>

                          <div class="field-check uk-width-1-4@m">
                            <label class="uk-form-label uk-visible@m">&nbsp;</label>
                            <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> {{i18n["step4-debitaccountholdererror"]}}</span>
                            <span class="uk-form-success uk-visible@m" v-show="dirty && passed"><i class="fas fa-check"></i></span>
                          </div>
                        </ValidationProvider>

                        <ValidationProvider name="debitIban" rules="required|iban" v-slot="{ failed, dirty, passed, classes }" tag="div" class="uk-child-width-expand@s" uk-grid>
                          <div>
                            <label class="uk-form-label" for="debitIban">IBAN</label>
                            <div class="uk-form-controls uk-position-relative">
                              <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="dirty && passed"></i>
                              <input name="debitIban" class="uk-input" v-model="customer.payment.debit.iban" type="text" :class="classes">
                            </div>
                          </div>

                          <div class="field-check uk-width-1-4@m">
                            <label class="uk-form-label uk-visible@m">&nbsp;</label>
                            <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> {{i18n["step4-debitibanerror"]}}</span>
                            <span class="uk-form-success uk-visible@m" v-show="dirty && passed"><i class="fas fa-check"></i></span>
                          </div>
                        </ValidationProvider>

                        <ValidationProvider name="debitBic" rules="" v-slot="{ failed, dirty, passed, classes }" tag="div" class="uk-child-width-expand@s" uk-grid>
                          <div>
                            <label class="uk-form-label" for="debitBic">BIC</label>
                            <div class="uk-form-controls uk-position-relative">
                              <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="dirty && passed && customer.payment.debit.bic.length > 0"></i>
                              <input name="debitBic" class="uk-input" v-model="customer.payment.debit.bic" type="text" :class="classes">
                            </div>
                          </div>

                          <div class="field-check uk-width-1-4@m">
                            <label class="uk-form-label uk-visible@m">&nbsp;</label>
                            <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> {{i18n["step4-debitbicerror"]}}</span>
                            <span class="uk-form-success uk-visible@m" v-show="dirty && passed && customer.payment.debit.bic.length > 0"><i class="fas fa-check"></i></span>
                          </div>
                        </ValidationProvider>

                        <ValidationProvider name="debitMandate" :rules="{ required: { allowFalse: false } }" v-slot="{ failed, dirty, passed, classes}" tag="div" class="uk-child-width-expand@s" uk-grid>
                          <div>
                            <label class="uk-checkbox-label"><input class="uk-checkbox" name="mandateAccepted" v-model="customer.mandateAccepted" type="checkbox" :class="classes" :value="true"> {{i18n["step4-debitsepamandate"]}}</label>
                          </div>

                          <div class="field-check uk-width-1-4@m">
                            <label class="uk-form-label uk-visible@m">&nbsp;</label>
                            <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> {{i18n["step4-debitsepamandateerror"]}}</span>
                            <span class="uk-form-success uk-visible@m" v-show="dirty && passed"><i class="fas fa-check"></i></span>
                          </div>
                        </ValidationProvider>
                      </template>

                       <div class="uk-flex uk-flex-between uk-margin-top">
                        <button class="uk-button uk-button-secondary" type="button" v-on:click="previousStep"><i class="fas fa-arrow-left"></i> {{["i18n"]["button-previous"]}}</button>
                        <button class="uk-button uk-button-primary" type="submit" :disabled="invalid || checkField !== ''">{{i18n["button-next"]}} <i class="fas fa-arrow-right"></i></button>
                      </div>
                    </form>
                  </ValidationObserver>
                </li>

                <li v-if="step === 6">
                  <ValidationObserver ref="step5" v-slot="{ invalid, handleSubmit }" tag="div">
                    <form class="uk-form-stacked" novalidate @submit.prevent="handleSubmit(signup)">
                      <div class="uk-width-1-2@m uk-text-center uk-margin-auto uk-margin">
                        <div class="uk-clearfix" v-html="i18n['finish-content']"></div>
                        <hr />

                        <ValidationProvider name="termsAccepted" :rules="{ required: { allowFalse: false } }" v-slot="{ failed, dirty, classes}" tag="div">
                          <div class="uk-margin">
                            <label class="uk-checkbox-label"><input class="uk-checkbox" name="termsAccepted" v-model="customer.termsAccepted" type="checkbox" :class="classes" :value="true"> <span v-html="i18n.terms"></span></label>
                          </div>

                          <div>
                            <div class="uk-margin uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> {{i18n["termserror"]}}</div>
                          </div>
                        </ValidationProvider>
                      </div>

                      <div class="errorDisplay">
                        <div v-show="orderSucceeded === false" class="uk-alert uk-alert-danger uk-margin uk-width-1-1" >
                          <div v-html="i18n['step4-generalerror']"></div>
                          <p>{{orderError}}</p>
                        </div>

                        <div v-show="paymentVerified === false && customer.payment.type === 'ccard'" class="uk-alert uk-alert-danger uk-margin uk-width-1-1">
                          <div v-html="i18n['step4-ccvalidationerror']"></div>
                        </div>

                        <div v-show="paymentVerified === false && customer.payment.type === 'debit'" class="uk-alert uk-alert-danger uk-margin uk-width-1-1">
                          <div v-html="i18n['step4-debiterrortext']"></div>
                        </div>

                        <div class="uk-width-1-2@m uk-text-center uk-margin-auto">
                            <button class="uk-button uk-button-primary uk-display-block uk-margin-auto uk-button-large" type="submit" :disabled="invalid || status === 'saving'"><template v-if="status === 'saving'"> ...</template><template v-else>{{i18n['finish-button-complete2']}}</template></button>
                            <button class="uk-button uk-button-secondary uk-display-block uk-margin-auto uk-margin-top" type="button" v-on:click="previousStep"><i class="fas fa-arrow-left"></i> {{i18n["button-previous"]}}</button>
                        </div>
                      </div>
                    </form>
                  </ValidationObserver>
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>

      <div class="sidebar uk-width-1-3@m">
        <div>
          <div class="summary uk-position-relative" :class="{working: status === 'updateing_summary' || status === 'saving', 'uk-hidden': status === 'done'}" style="z-index: 980;">
            <div class="logo_wrap uk-text-center">
              <oc-logo :animated="'animated'" class="uk-margin-bottom"></oc-logo>
            </div>

            <div class="summary_content uk-text-small">
              <div>
                <h3>{{i18n.plans[this.customer.plan.variant].name}}</h3>
                <div v-html="i18n.plans[this.customer.plan.variant].intro"></div>
              </div>

              <div v-show="billwerk.plans.cloudoffice.booked">
                <h3>+ Cloud Office</h3>
                <div v-html="i18n.plans.cloudoffice.intro"></div>
              </div>

              <table class="uk-table uk-table-small uk-table-divider">
                <thead>
                  <tr>
                    <th>
                      {{i18n["order_summary"]["buy-summary-item"]}}
                    </th>
                    <th>
                      {{i18n["order_summary"]["buy-summary-price"]}}
                    </th>
                  </tr>
                </thead>
                <tr>
                  <td>
                    {{customer.plan.users}} {{i18n["order_summary"]["buy-summary-users"]}} <br />
                    {{totalStorageComp}}
                  </td>
                  <td>
                    {{preview.Total | currency(currencies[activeCurrency])}} <template v-if="customer.plan.interval === 'yearly'"> {{i18n["buy-summary-peryear"]}}</template><template v-else> {{i18n["buy-summary-permonth"]}}</template>
                  </td>
                </tr>
                <tr v-show="customer.plan.interval === 'yearly' && typeof this.customer.plan.variant.monthly !== 'undefined'" class="highlight">
                  <td>
                    {{i18n["order_summary"]["buy-summary-savings"]}} ({{yearlySavingsProcComp}}%)
                  </td>
                  <td>
                    - {{yearlySavingsComp | currency(currencies[activeCurrency])}}
                  </td>
                </tr>
                <tr v-show="coupon.status">
                  <td>
                    Coupon-Code
                  </td>
                  <td>
                    {{customer.data.coupon}}
                  </td>
                </tr>
                <tr v-show="billwerk.plans.cloudoffice.booked">
                  <td>
                    Cloud-Office
                  </td>
                  <td>
                    {{cloudOfficePriceComp | currency(currencies[activeCurrency])}}
                  </td>
                </tr>
                <tr v-show="vat > 0">
                  <td>
                    {{i18n["order_summary"]["buy-summary-vat"]}} ({{vat}} %)
                  </td>
                  <td>
                    {{preview.TotalVat | currency(currencies[activeCurrency])}}
                  </td>
                </tr>
                <tr class="total">
                  <td class="uk-text-bold">
                    Total:
                  </td>
                  <td class="uk-text-bold">
                    {{preview.TotalGross | currency(currencies[activeCurrency])}} <template v-if="customer.plan.interval === 'yearly'">per year</template><template v-else>per month</template>
                  </td>
                </tr>
              </table>

              <div class="currency-chooser uk-flex">
                <div v-bind:class="{'active': activeCurrency === 'euro'}" class="uk-width-1-4 uk-text-center" v-on:click="activeCurrency = 'euro'">
                  <font-awesome-icon :icon="['fas', 'euro-sign']"></font-awesome-icon>
                </div>

                <div v-bind:class="{'active': activeCurrency === 'dollar'}" class="uk-width-1-4 uk-text-center" v-on:click="activeCurrency = 'dollar'">
                  <font-awesome-icon :icon="['fas', 'dollar-sign']"></font-awesome-icon>
                </div>

                <div v-bind:class="{'active': activeCurrency === 'pound'}" class="uk-width-1-4 uk-text-center" v-on:click="activeCurrency = 'pound'">
                  <font-awesome-icon :icon="['fas', 'pound-sign']"></font-awesome-icon>
                </div>

                <div v-bind:class="{'active': activeCurrency === 'yen'}" class="uk-width-1-4 uk-text-center" v-on:click="activeCurrency = 'yen'">
                  <font-awesome-icon :icon="['fas', 'yen-sign']"></font-awesome-icon>
                </div>

                <div v-bind:class="{'active': activeCurrency === 'bitcoin'}" class="uk-width-1-4 uk-text-center" v-on:click="activeCurrency = 'bitcoin'">
                  <font-awesome-icon :icon="['fab', 'bitcoin']"></font-awesome-icon>
                </div>
              </div>
            </div>
          </div>
          <div class="note">
            {{i18n["order_summary"]["buy-summary-rates-text"] | replace('date', rates.date)}}
            Exchange rates are dated {{this.rates.date}} and are meant as guidance. Exact price will be calculated on checkout.
          </div>

          <div class="uk-margin-top" v-html="this['i18n']['buy-left_sidebar']"></div>

        </div>
      </div>
    </div>
    <div class="loading-overlay" :class="{'visible': status === 'saving'}">
        <ocLogo :animated="true"></ocLogo>
    </div>
  </div>
</template>

<script>
import ocLogo from '../components/oc-logo'
import i18nIsoCountries from 'i18n-iso-countries'
import { ValidationProvider, ValidationObserver, validate } from 'vee-validate'
import CardValidator from 'card-validator'
import Axios from 'axios'
import qs from 'qs'
import { isEuMember, getEuMembers } from 'is-eu-member'

export default {
  name: 'Buy',
  components: {
    ocLogo,
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      // eslint-disable-next-line no-undef
      wpParams: ajax_params,
      status: 'idle',
      checkField: '', // enter a name of an input field to display a loading icon besides it
      checkFieldDelay: null, // variable for setTimout on email check
      processing: false,
      thisYear: new Date().getFullYear(),
      logoanimated: false, // logo overlay visible and logo animated
      minCcExpiryDate: '', // todays date
      countries: i18nIsoCountries,
      step: 1,
      orderSucceeded: true,
      orderError: '',
      paymentVerified: true,
      rates: {},
      emailValid: null,

      storageFixed: false, // set true if dynamic storage calculation should be overwritten
      storageFixedAmount: '', // set storage amount (string)

      currencies: {
        euro: {
          symbol: '€',
          factor: 1,
          decimals: 2
        },
        dollar: {
          symbol: '$',
          factor: 0,
          decimals: 2
        },
        yen: {
          symbol: '¥',
          factor: 0,
          decimals: 0
        },
        bitcoin: {
          symbol: 'BTC',
          factor: 0,
          decimals: 6
        },
        pound: {
          symbol: '£',
          factor: 0,
          decimals: 2
        }
      },
      activeCurrency: 'euro', // selected currency
      customer: {
        type: 'B',
        vatValid: null,
        plan: {
          variant: '',
          interval: 'yearly',
          users: 5
        },
        data: {
          coupon: '',
          company: '',
          email: '',
          firstName: '',
          lastName: '',
          street: '',
          postalCode: '',
          city: '',
          country: null,
          phone: '',
          vat: '',
          vatprefix: null,
          instanceId: ''
        },
        payment: {
          type: 'ccard',
          country: false,
          debit: {
            bearer: 'Debit:Stripe',
            accountHolder: '',
            iban: '',
            bic: ''
          },
          ccard: {
            bearer: 'CreditCard:Stripe',
            cardNumber: '',
            expiryMonth: null,
            expiryYear: null,
            cardHolder: '',
            cvc: '',
            country: null
          },
          cardType: '' // gets filled on validation
        },
        termsAccepted: false,
        mandateAccepted: false,
        order: {} // order sent back from backend on upgrade
      },
      vat: 0,
      billwerk: {
        plans: {
          basic: {
            minUsers: 1,
            yearly: {
              id: process.env.VUE_APP_BASIC_YEARLY,
              component: process.env.VUE_APP_USER_BASIC_YEARLY,
              price: 180
            },
            monthly: {
              id: process.env.VUE_APP_BASIC_MONTHLY,
              component: process.env.VUE_APP_USER_BASIC_MONTHLY,
              price: 18
            }
          },
          advanced: {
            minUsers: 5,
            yearly: {
              id: process.env.VUE_APP_ADVANCED_YEARLY,
              component: process.env.VUE_APP_USER_ADVANCED_YEARLY,
              price: 156
            },
            monthly: {
              id: process.env.VUE_APP_ADVANCED_MONTHLY,
              component: process.env.VUE_APP_USER_ADVANCED_MONTHLY,
              price: 16
            }
          },
          cloudoffice: {
            booked: false,
            yearly: {
              component: process.env.VUE_APP_USER_OFFICE_YEARLY,
              price: 48
            },
            monthly: {
              component: process.env.VUE_APP_USER_OFFICE_MONTHLY,
              price: 4
            }
          },
          educational: {
            selected: 's',
            yearly: {},
            s: {
              id: process.env.VUE_APP_EDU_SMALL,
              price: 990,
              storage: '1TB',
              users: 25
            },
            m: {
              id: process.env.VUE_APP_EDU_MEDIUM,
              price: 1990,
              storage: '2TB',
              users: 60
            },
            l: {
              id: process.env.VUE_APP_EDU_LARGE,
              price: 3780,
              storage: '4TB',
              users: 150
            },
            xl: {
              id: process.env.VUE_APP_EDU_XLARGE,
              price: 9900,
              storage: '8TB',
              users: 999
            }
          }
        },
        apiKey: process.env.VUE_APP_BILLWERK_API_KEY,
        // eslint-disable-next-line no-undef
        providerReturnUrl: i18n['buy-thankyou-page']
      },
      preview: {
        Total: 0, // total price
        TotalGross: 0, // total price with tax
        TotalVat: 0 // total vat
      },
      coupon: {
        delay: '',
        preview: {},
        status: false
      },
      // eslint-disable-next-line no-undef
      i18n: i18n // value given by wordpress as global variable, see template-buy.php
    }
  },
  methods: {
    previousStep: function () {
      if (this.customer.plan.variant === 'educational' && this.step === 5) {
        this.step = this.step - 2
      } else {
        this.step = this.step - 1
      }

      this.$scrollTo('body')
    },
    toStep: function (nextStep) {
      if (this.customer.plan.variant === 'educational' && nextStep === 4) {
        nextStep = 5
      }

      switch (this.step) {
        case 5:
          this.orderPreview()
          break
      }

      this.step = nextStep
      this.$scrollTo('h1')

      switch (this.step) {
        case 4:
          this.sendData()
          this.$cookies.set('e', JSON.stringify({ email: this.customer.data.email, firstname: this.customer.data.firstName }), {
            expires: '2d'
          })
          break

        case 5:
          this.orderPreview()
          break

        case 6:
          this.orderSucceeded = true
          this.orderSucceeded = true
          this.paymentVerified = true
          break
      }
    },
    orderPreview: function () {
      return new Promise((resolve, reject) => {
        this.status = 'updateing_summary'

        this.signupService.preview(
          this.cartComp,
          this.customerComp,
          (previewData) => {
            // success
            this.customer.vatValid = true

            if (this.billwerk.plans.cloudoffice.booked) {
              this.preview.Total = previewData.Order.Total - (this.customer.plan.users * this.billwerk.plans.cloudoffice[this.customer.plan.interval].price)
            } else {
              this.preview.Total = previewData.Order.Total
            }

            this.preview.TotalGross = previewData.Order.TotalGross
            this.preview.TotalVat = previewData.Order.TotalVat
            this.vat = Math.round((previewData.Order.TotalVat / previewData.Order.Total) * 100)

            this.coupon.preview = previewData.Order.Coupon
            if (typeof previewData.Order.Coupon !== 'undefined') {
              if (typeof previewData.Order.Coupon.ErrorMessage !== 'undefined') { this.coupon.status = false } else {
                this.coupon.status = true
              }
            }

            this.status = 'idle'
            this.checkField = ''
            resolve()
          },
          (errorData) => {
            const obj = JSON.parse(errorData.errorMessage)

            // error
            if (obj.Error.Message.indexOf('not a valid VAT ID') > -1) {
              this.$refs.step2.setErrors({
                vat: this.i18n['step2-vaterror']
              })
              this.customer.vatValid = false
            }

            this.status = 'idle'
            this.checkField = ''
          }
        )
      })
    },

    // ------------ SIGNUP (UPGRADE & NEW) -------------

    /**
    * Initializes the signup process
    *
    */
    signup: function () {
      if (this.processing) {
        return false
      }

      this.processing = true

      // start order process
      this.logoanimated = true
      this.status = 'saving'

      Axios.post('',
        qs.stringify({
          action: 'signupworker',
          subaction: 'signup',
          security: window.ajax_params.nonce,
          customer: this.customerComp,
          cart: this.cartComp
        })
      )
        .then(response => {
          switch (response.data.success) {
            case 1:
              this.createNewCustomerOrder()
              break

            case 2:
              this.customer.order = response.data.order
              this.customer.portal = new SubscriptionJS.Portal(response.data.selfServiceToken.Token)
              // update customer data
              this.customer.portal.customerChange(
                this.customerComp,
                this.paymentChange,
                (error) => {
                  // Does whatever an error handler does, e.g. display an error message to the user
                  this.showError('customerdataUpdateFailed', error)
                }
              )
              break

            case 3:
            // email address is already used in a full account; Skip Signup process
              this.finalize(this.billwerk.providerReturnUrl + '?3ds=no')
              break

            case 0:
              this.status = 'idle'
              this.logoanimated = false
              this.processing = false

              switch (response.data.message) {
                case 'invalid_email':
                  this.$refs.step3.setErrors({
                    email: response.data.message
                  })
                  break

                default:
                  this.status = 'error'
                  break
              }
              break
          }
        }, response => {
          this.showError('billwerkInitFailed')
        })
      return false
    },

    /**
     * Update customers' payment data
     */
    paymentChange: function () {
      var paymentService = new SubscriptionJS.Payment({
        publicApiKey: this.billwerk.apiKey,
        providerReturnUrl: this.billwerk.providerReturnUrl
      },
      (data) => {
        // initialized
        var secretPaymentData = this.customer.payment[this.customer.payment.type]

        this.customer.portal.paymentChange(paymentService, secretPaymentData,
          (data) => {
            this.prepareUpgrade()
          },
          (error) => {
            // Does whatever an error handler does, e.g. display an error message to the user            
            this.showError('paymentFailed', error)
          }
        )
      },
      (error) => {
        this.showError('billwerkInitFailed', error)
      }
      )
    },

    showError: function (code) {
      this.processing = false
      this.status = 'idle'

      switch (code) {
        case 'billwerkInitFailed': // BillwerkJS could not be initialized
        case 'customerdataUpdateFailed': // Updateing customer data failed
          this.orderSucceeded = false
          break

        case 'paymentFailed':
          // Could not update customers' payment data
          this.paymentVerified = false
          break
      }

      this.$scrollTo('.errorDisplay')
    },
    // --------------- METHODS FOR CUSTOMER UPGRADE (=Trial already existing) -------------

    /**
    * Creates a new order via API
    *
    */
    createUpgradeOrder: function () {
      // Set updated customer data
      Axios.post('', qs.stringify({
        action: 'signupworker',
        subaction: 'createOrder',
        security: window.ajax_params.nonce,
        customer: {
          data: this.customerComp,
          cart: this.cartComp
        },
        origin: window.location.href

      }))
        .then(response => {
          if (response.data.success > 0) {
            this.customer.order = response.data
            this.updateCustomerData()
          } else {
            this.showError('billwerkInitFailed')
          }
        }, response => {
        })
    },

    /**
    * Prepares the upgrade by initializing BillwerkJS
    *
    */
    prepareUpgrade: function (data) {
      // eslint-disable-next-line
      this.paymentService = new SubscriptionJS.Payment({
        publicApiKey: this.billwerk.apiKey,
        providerReturnUrl: this.billwerk.providerReturnUrl
      },
      () => {
        this.commitUpgrade()
      },
      () => { // error
        this.showError('billwerkInitFailed')
      })
    },

    initPaymentService: function () {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line
        this.paymentService = new SubscriptionJS.Payment({
          publicApiKey: this.billwerk.apiKey,
          providerReturnUrl: this.billwerk.providerReturnUrl
        },
        resolve(),
        () => { // error
          this.showError('paymentFailed')
        })
      })
    },

    /**
    * Does the actual upgrade
    *
    */
    commitUpgrade: function () {
      this.customer.portal.upgradePayInteractive(this.paymentService, this.customer.payment[this.customer.payment.type], this.customer.order,
        (data) => {
          // Everything went well
          if (data.Url) {
            this.finalize(data.Url) // Forward to PSP page to pay
          } else {
            this.finalize(this.billwerk.providerReturnUrl + '?3ds=no') // forward to thank you page
          }
        },
        (error) => {
          // Does whatever an error handler does, e.g. display an error message to the user
          this.showError('paymentFailed', error)
        }
      )
    },

    /**
    * Clean up
    *
    */
    finalize: function (forwardUrl) {
      // make last api call and forward to thank you page
      Axios.post('',
        qs.stringify({
          action: 'signupworker',
          subaction: 'finalize',
          security: window.ajax_params.nonce,
          customer: {
            email: this.customer.data.email,
            state: this.$store.state.customer.state
          },
          origin: window.location.href
        })
      )
      window.location.href = forwardUrl
    },

    // --------------- METHODS FOR NEW CUSTOMER SIGNUP -------------

    /**
    * Initializes Billwerk JS
    *
    */
    createNewCustomerOrder: function () {
      // eslint-disable-next-line
      this.paymentService = new SubscriptionJS.Payment({
        publicApiKey: this.billwerk.apiKey,
        providerReturnUrl: this.billwerk.providerReturnUrl
      },
      () => { // ready
        this.createOrder()
      },
      () => { // error
        this.showError('billwerkInitFailed')
        this.processing = false
      })
    },

    /**
    * Create the actual order
    *
    */
    createOrder: function () {
      this.signupService.createOrder(
        this.cartComp,
        this.customerComp,
        this.pay, // Order created. Go on...
        (errorData) => {
          // Order could not be generated
          this.orderSucceeded = false
          this.processing = false
          this.orderError = errorData.errorMessage
          this.status = 'idle'
        }
      )
    },

    /**
    * Start payment process
    *
    */

    pay: function (order) {
      this.signupService.paySignupInteractive(
        this.paymentService,
        this.customer.payment[this.customer.payment.type],
        order,
        (subscription) => {
          if (!subscription.Url) {
            this.finalize(this.billwerk.providerReturnUrl + '?3ds=no')
          } else {
            this.finalize(subscription.Url)
          }
        },
        (errorData) => {
          // errorhandler
          this.paymentVerified = false
          this.processing = false
          this.status = 'idle'
        }
      )
    },

    // ---------------- END OF SIGNUP METHODS -----------

    /**
    * Sends data to backend to save temporarily in session, e.g. when user leaves
    * the order page after data input to prefill the form
    */
    sendData: function () {
      Axios.post('',
        qs.stringify({
          action: 'setCustomerTemp',
          security: window.ajax_params.nonce,
          customer: {
            data: this.customer.data,
            plan: this.customer.plan
          },
          origin: window.location.href
        })
      )
        .then(response => {

        }, response => {

        })
    },

    /**
    * Gets data from backend session, e.g. when user leaves
    * the order page after data input to prefill the form
    */
    getData: function () {
      Axios.post('',
        qs.stringify({
          action: 'getCustomerTemp'
        })
      )
        .then(response => {
          if (typeof (response.data.customer) !== 'undefined' && response.data.customer !== false) {
            this.customer.data = response.data.customer.data
            this.customer.plan = response.data.customer.plan
          }
        }, response => {

        })
    },

    /* EDUCATIONAL STUFF */
    eduSelect: function (size) {
      this.billwerk.plans.educational.selected = size
      this.customer.plan.interval = 'yearly'
      this.customer.plan.users = this.billwerk.plans.educational[this.billwerk.plans.educational.selected].users
      this.billwerk.plans.educational.yearly = this.billwerk.plans.educational[this.billwerk.plans.educational.selected]
      this.storageFixed = true
      this.storageFixedAmount = this.billwerk.plans.educational[this.billwerk.plans.educational.selected].storage
      this.orderPreview()
    }
  },
  created: function () {
    this.customer.plan.variant = this.$route.params.package // router.js makes sure to have a package name set

    if (typeof this.billwerk.plans[this.customer.plan.variant].minUsers !== 'undefined') { this.customer.plan.users = this.billwerk.plans[this.customer.plan.variant].minUsers }
  },
  mounted: function () {    
    if (this.$route.params.cloudoffice === 'cloudoffice') {
      this.billwerk.plans.cloudoffice.booked = true

      if (typeof (this.$route.params.step) !== 'undefined') {
        this.step = parseInt(this.$route.params.step)
      }
    } else {
      this.billwerk.plans.cloudoffice.booked = false

      if (typeof (this.$route.params.cloudoffice) !== 'undefined') {
        this.step = parseInt(this.$route.params.cloudoffice)
      }
    }

    // is set if request is an upgrade
    this.customer.data.email = this.$store.state.customer.email
    this.customer.data.instanceId = this.$store.state.customer.instanceId

    this.countries.registerLocale(require('i18n-iso-countries/langs/' + this.i18n.language + '.json'))

    this.getData()

    // Initialize Billwerk SignupService
    // eslint-disable-next-line
    this.signupService = new SubscriptionJS.Signup()

    if (this.customer.plan.variant === 'educational') {
      this.eduSelect('s')
    }

    // set min date for credit card expiry date
    var today = new Date()
    var mm = today.getMonth() + 1
    var yyyy = today.getFullYear()
    mm++
    if (mm < 10) {
      mm = '0' + mm
    }

    this.minCcExpiryDate = yyyy + '-' + mm

    // get current exchange rates
    Axios.post('',
      qs.stringify({
        action: 'getRates',
        security: window.ajax_params.nonce
      })
    )
      .then(response => {
        this.rates = response.data

        this.currencies.euro.factor = 1
        this.currencies.dollar.factor = this.rates.rates.USD
        this.currencies.yen.factor = this.rates.rates.JPY
        this.currencies.pound.factor = this.rates.rates.GBP
        this.currencies.bitcoin.factor = this.rates.rates.BTC
      })

    this.orderPreview()
  },
  computed: {
    yearlySavingsComp: function () {
      return (this.monthlyTotalComp * 12) - this.yearlyTotalComp
    },
    yearlySavingsProcComp: function () {
      return Math.round((((this.monthlyTotalComp * 12) / this.yearlyTotalComp) - 1) * 100)
    },
    yearlyTotalComp: function () {
      return this.billwerk.plans[this.customer.plan.variant].yearly.price * this.customer.plan.users
    },
    monthlyTotalComp: function () {
      if (typeof this.billwerk.plans[this.customer.plan.variant].monthly !== 'undefined') { return this.billwerk.plans[this.customer.plan.variant].monthly.price * this.customer.plan.users } else {
        return 0
      }
    },
    cartComp: function () {
      var components = []

      if (typeof this.billwerk.plans[this.customer.plan.variant][this.customer.plan.interval].component !== 'undefined') {
        components = [{
          componentId: this.billwerk.plans[this.customer.plan.variant][this.customer.plan.interval].component,
          quantity: this.customer.plan.users
        }
        ]
      }

      if (this.billwerk.plans.cloudoffice.booked) {
        components.push({
          componentId: this.billwerk.plans.cloudoffice[this.customer.plan.interval].component,
          quantity: this.customer.plan.users
        })
      }

      return {
        planVariantId: this.billwerk.plans[this.customer.plan.variant][this.customer.plan.interval].id,
        couponCode: this.customer.data.coupon,
        componentSubscriptions: components
      }
    },
    customerComp: function () {
      var country, locale

      if (this.customer.data.country === 'DE' || this.customer.data.country === 'CH' || this.customer.data.country === 'AT') {
        locale = 'de-DE'
      } else {
        locale = 'en-US'
      }

      if (this.customer.data.country === null) {
        country = 'de'
      } else {
        country = this.customer.data.country
      }

      // Include VatId entity only if country requires a VatId. Otherwise request to billwerk eventually fails
      let vatObj = {}
      if (this.vatRequired) {
        vatObj.VatId = this.vatComp
      }

      let options = {
        'FirstName': this.customer.data.firstName,
        'LastName': this.customer.data.lastName,
        'EmailAddress': this.customer.data.email,
        'PhoneNumber': this.customer.phone,
        'CompanyName': this.customer.data.company,
        'Address': {
          'Street': this.customer.data.street,
          'PostalCode': this.customer.data.postalCode,
          'City': this.customer.data.city,
          'Country': country
        },
        'Locale': locale
      }

      return { ...options, ...vatObj }
    },
    cloudOfficePriceComp: function () {
      return this.billwerk.plans.cloudoffice[this.customer.plan.interval].price * this.customer.plan.users
    },
    vatComp: function () {
      if (this.customer.data.vat.length > 0) {
        return this.customer.data.vatprefix + this.customer.data.vat
      } else {
        return null
      }
    },
    vatRequired: function () {
      if (this.customer.type === 'B' && this.customer.data.country !== null) {
        return isEuMember(this.customer.data.country)
      } else {
        return false
      }
    },
    ccyears: function () {
      const year = new Date().getFullYear()
      return Array.from({ length: 10 }, (value, index) => year + index)
    },
    ccmonths: function () {
      var year = new Date().getFullYear()
      var month = new Date().getMonth()
      if (this.customer.payment.ccard.expiryYear === year) {
        return Array.from({ length: 11 - month }, (value, index) => month + index + 2)
      } else {
        return Array.from({ length: 12 }, (value, index) => 1 + index)
      }
    },
    totalStorageComp: function () {
      if (this.storageFixed) {
        return this.storageFixedAmount
      } else {
        if (this.customer.plan.users < 5) {
          return '500 GB'
        } else if (this.customer.plan.users >= 15) {
          let storage = this.customer.plan.users * 0.2
          let suffix = ' TB'

          return storage.toFixed(1) + suffix
        } else {
          let storage = this.customer.plan.users * 200
          let suffix = ' GB'

          return storage + suffix
        }
      }
    },
    europeanCountries: () => getEuMembers()
  },
  watch: {
    'customer.plan': {
      handler: function (after, before) {
        this.orderPreview()
      },
      deep: true
    },
    'customer.type': function (after, before) {
      this.orderPreview()
    },
    'customer.data.email': function (after, before) {
      if (this.checkFieldDelay !== null) {
        clearTimeout(this.checkFieldDelay)
      }
      this.checkFieldDelay = setTimeout(() => {
        this.checkField = 'email'
        this.emailValid = true
        this.$store.dispatch('validateEmail', this.customer.data.email)
          .then(() => {
            this.checkField = ''
            validate(this.customer.data.email, 'email').then(result => {
              if (result.valid) {
                this.$refs.step3.setErrors({
                  email: ''
                })
              }
            })
          },
          (message) => {
            switch (message) {
              case 'invalid_email':
                this.emailValid = false
                break

              default:
                this.status = 'error'
                break
            }
            this.checkField = ''
          })
      }, 300)
    },
    vatComp: function (after, before) {
      // replace invalid characters
      this.customer.data.vat = after.replace(/[-.●]/, '')

      if (this.customer.data.vat.substr(0, 2) === this.customer.data.vatprefix) {
        this.customer.data.vat = after.substr(2)
      }

      if (this.customer.data.vat.length > 0) {
        this.$refs.step2.setErrors({
          vat: null
        })

        clearTimeout(this.checkFieldDelay)
        this.checkField = 'vat'

        this.checkFieldDelay = setTimeout(() => {
          this.orderPreview()
        },
        500)
      }
    },
    'customer.data.vatprefix': function (after, before) {
      if (this.customer.data.vat.substr(0, 2) === this.customer.data.vatprefix) {
        this.customer.data.vat = this.customer.data.vat.substr(2)
      }
    },
    'customer.data.coupon': function (after, before) {
      clearTimeout(this.coupon.delay)
      if (this.customer.data.coupon.length > 0) {
        this.coupon.delay = setTimeout(() => {
          this.checkField = 'coupon'
          this.orderPreview().then(() => {
            if (typeof this.coupon.preview.ErrorMessage !== 'undefined') {
              this.$refs.step1.setErrors({
                coupon: ['Invalid Coupon']
              })
            }
            this.checkField = ''
          })
        }, 700)
      } else {
        this.$refs.step1.reset()
      }
    },
    'customer.data.country': function (after, before) {
      this.customer.data.vatprefix = after
      this.customer.payment.ccard.country = after
      this.orderPreview()
    },
    'customer.payment.ccard.cardNumber': function (after, before) {
      // add spaces every 4 characters
      this.customer.payment.ccard.cardNumber = after.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()

      var card = CardValidator.number(this.customer.payment.ccard.cardNumber)

      if (card.card !== null) {
        this.customer.payment.cardType = card.card.niceType
      } else {
        this.customer.payment.cardType = ''
      }
    },
    'customer.payment.ccard.expiryYear': function (after, before) {
      var month = new Date().getMonth()

      if (after === this.thisYear) {
        var validMonths = Array.from({ length: 11 - month }, (value, index) => month + index + 2)
        if (!validMonths.includes(this.customer.payment.ccard.expiryMonth)) {
          this.customer.payment.ccard.expiryMonth = null
        }
      }
    },
    'billwerk.plans.cloudoffice.booked': function (after, before) {
      this.orderPreview()
    },
    '$route.params.package': function (id) {
      this.customer.plan.variant = this.$route.params.package
    },
    'customer.plan.users': function (after, before) {
      if (this.customer.plan.variant !== 'educational') {
        if (after >= 5) {
          this.$router.replace({ name: 'Buy', params: { package: 'advanced' } })
        } else {
          this.$router.replace({ name: 'Buy', params: { package: 'basic' } })
        }
      }
    },
    'customer.payment.type': function () {
      this.$refs.step5.reset()
    }
  }
}
</script>

<style scoped lang="scss">
  @import 'Buy';
</style>
